import { Injectable } from '@angular/core';
import { Statistics } from 'app/trello/models/board-summary';
import { LabelChartData } from 'app/trello/models/charts';
import { StatisticsAggregator } from 'app/trello/utility/statistics-aggregator';
import { StructureTransformer } from 'app/trello/utility/structure-transformer';

@Injectable({
  providedIn: 'root'
})
export class LabelChartDataAggregator {

  constructor(
    private readonly statisticsAggregator: StatisticsAggregator,
    private readonly statisticsTransformer: StructureTransformer,
  ) {
  }

  public aggregate(
    stats: Statistics,
    aggregationLevel: 'day' | 'week' | 'month' = 'day'
  ): LabelChartData {

    const totalLabelCardsData =
      this.statisticsAggregator.aggregateCountDistinct(
        stats.label.total.day || {},
        aggregationLevel,
      );

    const labelAddedData =
      this.statisticsAggregator.aggregateCountDistinct(
        this.statisticsTransformer.mergeInnerArrays2D(stats.label.added) || {},
        aggregationLevel,
      );

    const labelRemovedData =
      this.statisticsAggregator.aggregateCountDistinct(
        this.statisticsTransformer.mergeInnerArrays2D(stats.label.removed) || {},
        aggregationLevel,
      );

    const labelDurationData =
      this.statisticsAggregator.aggregateDuration(
        this.statisticsTransformer.collectInnerValues2D(stats.label.duration) || {},
        aggregationLevel,
      );

    return {
      totalCards: totalLabelCardsData,
      added: labelAddedData,
      removed: labelRemovedData,
      duration: labelDurationData,
    };
  }

}
